(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-banner"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const bannerContent = document.querySelector('.sticky-banner__content[data-invert="true"]')
        if(!!!bannerContent) return
        
        window.addEventListener("scroll", () => {
            if(window.scrollY > 250) {
                bannerContent.classList.add('sticky-banner__content--inverted')
            } else {
                bannerContent.classList.remove('sticky-banner__content--inverted')
            }
        })
    })

  } catch(e) { console.error(e); }
})();
})();
